// extracted by mini-css-extract-plugin
export var backdrop = "styles-module--backdrop--d80f9";
export var container = "styles-module--container--518eb";
export var content = "styles-module--content--960ed";
export var opened = "styles-module--opened--86345";
export var side = "styles-module--side--fa4ee";
export var sideToggle = "styles-module--sideToggle--5ef20";